import React from 'react';
import Helmet from 'react-helmet';
import { useIntl, Language } from 'ha/i18n';
import { TERMS } from 'ha/constants/pageNames';
import Page from 'ha/modules/Page';
import { Container, Typography } from '@ha/dsl';
import TermsEN from './TermsEN';
import TermsDE from './TermsDE';

const Translations = {
  [Language.en]: TermsEN,
  [Language.de]: TermsDE,
};

const TermsLayout: React.FC = () => {
  const { T, lang } = useIntl();
  const Content = Translations[lang] || Translations[Language.en];

  return (
    <Page name={TERMS}>
      <Container maxWidth="md" className="landing-plain-text">
        <Helmet>
          <title>{T('terms_header')}</title>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <Typography.H1>{T('terms_conditions_header')}</Typography.H1>
        <Content />
      </Container>
    </Page>
  );
};

export default TermsLayout;
